
import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import SelectPulldown from '@/components/molecules/SelectPulldown.vue'
import { SelectItem } from '@/models/SelectItem'

/**
 * フィルタリング用プルダウンメニュー
 */
@Component({
  components: {
    SelectPulldown,
    ButtonBase,
  },
})
export default class PulldownFilter extends Vue {
  /** プルダウンセレクト分子 */
  @Ref()
  selectPulldown!: SelectPulldown

  /** 選択肢のリスト */
  @Prop()
  private selectOptions!: SelectItem[]

  /** 初期選択値のコード */
  @Prop()
  private defaultOptionCode!: string

  /** ボタンのラベル */
  private labelButton: string = ''

  /**
   * 初期処理
   */
  private mounted(): void {
    this.setButtonLabel()
  }

  /**
   * 選択中の値を取得
   *
   * @returns 選択中の値
   */
  public selectedValue(): string {
    return this.selectPulldown.selectedValue()
  }

  /**
   * ラベルを更新し、値の変更を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private changeEvent(event: Event): void {
    this.setButtonLabel()
    this.$emit('change', event)
  }

  /**
   * ボタンのラベルを設定
   */
  private setButtonLabel(): void {
    this.labelButton = this.selectPulldown.getOptionLabel()
  }
}
